module.exports = __webpack_public_path__ + "img/briefcase.a4d10607.svg";